var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.2 7.00039L17.2 15.4004M17.2 15.4004L14.2 11.8004M17.2 15.4004L20.2 11.8004",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.80005 7.00039L8.80005 15.4004M8.80005 15.4004L5.80005 11.8004M8.80005 15.4004L11.8 11.8004",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.79995 19L13 19L20.2 19",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25 13C25 18.6569 25 21.4853 23.2426 23.2426C21.4853 25 18.6569 25 13 25C7.3432 25 4.51468 25 2.7574 23.2426C1 21.4853 1 18.6569 1 13C1 7.3432 1 4.51468 2.7574 2.7574C4.51468 0.999998 7.3432 0.999998 13 0.999998C18.6569 0.999998 21.4853 0.999999 23.2426 2.7574C25 4.51468 25 7.3432 25 13Z",
    stroke: "white",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDocuments);
export default __webpack_public_path__ + "static/media/downloadDocuments.0c5c8236164f7caef1f77d941253972b.svg";
export { ForwardRef as ReactComponent };